module.exports = __webpack_public_path__ + "img/fusion-reactor-equipment.f58dd33c.png";